// Income Actions

import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

// ***** Get incomeList from backend then update incomeList in vuex store ***** //
export const updateIncomeList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc',
      ...payload.advancedSearch,
      is_filtered: payload.isFiltered
    }
  }

  try {
    const result = await Axios.get('income_index', { params: params })
    const resultData = result.data.data
    let resultWithFooter = resultData.data
    resultWithFooter.footer = resultData.footer
    commit('updateIncomeList', resultWithFooter)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}

// ***** Get incomeList from backend then update incomeList in vuex store ***** //
export const updateReportIncomeList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc',
      outlet_id: payload.id,
      ...payload.advancedSearch,
      is_filtered: payload.isFiltered
    }
  }

  try {
    const result = await Axios.get(`report_incomes/${payload.id}`, { params: params })
    const resultData = result.data.data
    let resultWithFooter = resultData.data
    resultWithFooter.footer = resultData.footer
    commit('updateIncomeList', resultWithFooter)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}

// ***** Fetch Income from backend ***** //
export const fetchIncomeInfo = async ({ commit }, payload = null) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    const result = await Axios.get(`income_show/${payload}`)
    commit('fetchIncomeInfo', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Add Income  ***** //
export const addIncome = async (ignored, payload = null) => {
  try {
    await Axios.post('income_store', payload)
    helpers.ktNotify({
      type: 'success',
      text: 'Added Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, creation failed')
  }
}

// ***** Update Income  info ***** //
export const updateIncomeInfo = async (ignored, payload = null) => {
  if (!helpers.checkId(payload.id)) {
    throw new Error('Error')
  }

  try {
    payload.formData.append('_method', 'PATCH')
    await Axios.post(`income_update/${payload.id}`, payload.formData)
    helpers.ktNotify({
      type: 'success',
      text: 'Updated Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, update failed')
  }
}

// ***** Delete Income  ***** //
export const deleteIncome = async (ignored, payload) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    await Axios.delete(`income_destroy/${payload}`)
    helpers.ktNotify({
      type: 'success',
      text: 'Deleted Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, deletion failed')
  }
}
